// @flow
import * as React from 'react'
import { Button, Typography, Icon } from 'antd'
import { injectIntl } from 'react-intl'
import LocationContext from '../../LocationContext'

const { Text } = Typography

type EDHProps = {
  title: string,
  uid: string,
  image: string,
  imageSmall: string,
  backFn: () => void,
  intl: any,
}

type EDHState = {
  fixed: boolean,
  scrollScaling: number,
  scrollBg: number,
}

class EventDetailsHeader extends React.Component<EDHProps, EDHState> {
  state = {
    fixed: false,
    scrollScaling: 1,
    scrollBg: 0,
  }

  handleScroll = () => {
    const wrapper = document
      .getElementById(`event${this.props.uid}`)
      .closest('.ant-drawer-wrapper-body')
    const scrollTop = wrapper?.scrollTop ?? 0

    this.setState({
      fixed: scrollTop > 100,
      scrollScaling: 1 + Math.pow(scrollTop / window.innerWidth, 2),
      scrollBg: scrollTop / window.innerWidth,
    })
  }

  componentDidMount() {
    const wrapper = document
      .getElementById(`event${this.props.uid}`)
      .closest('.ant-drawer-wrapper-body')

    if (wrapper) wrapper.addEventListener('scroll', this.handleScroll)
  }

  componentWillUnmount() {
    const wrapper = document
      .getElementById(`event${this.props.uid}`)
      .closest('.ant-drawer-wrapper-body')

    if (wrapper) wrapper.removeEventListener('scroll', this.handleScroll)
  }

  render() {
    const { fixed, scrollScaling, scrollBg } = this.state
    const { title, imageSmall, image, intl } = this.props

    return (
      <LocationContext.Consumer>
        {({ toggleDetailOpen }) => (
          <React.Fragment>
            <div
              className={`event-details-back-button${fixed ? ' fixed' : ''}`}
            >
              <Button
                onClick={() => {
                  this.props.backFn()
                  toggleDetailOpen()
                }}
                type="link"
                title={intl.formatMessage({
                  id: 'eventdetail.back',
                  defaultMessage: 'Back',
                })}
              >
                <Icon type="arrow-left" />
              </Button>
              <Text ellipsis>{title}</Text>
            </div>
            <figure>
              <img
                src={imageSmall}
                alt={title}
                srcSet={image ? `${image} 2x` : imageSmall}
                style={{ transform: `scale(${scrollScaling})` }}
              />
              <div
                className="mask"
                style={{ background: `rgba(0, 0, 0, ${scrollBg})` }}
              />
            </figure>
          </React.Fragment>
        )}
      </LocationContext.Consumer>
    )
  }
}

export default injectIntl(EventDetailsHeader)
